import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { Button, Card } from 'flowbite-react';
import { Link, useRouteError } from 'react-router-dom';

import { FaIconLite } from 'src/components/fa-icon-lite';

export function UnexpectedError() {
  const error = useRouteError();
  return (
    <div className='flex min-h-screen items-center justify-center bg-gray-100 p-4'>
      <Card className='max-w-md text-center'>
        <FaIconLite icon={faTriangleExclamation} size='4x' className='mx-auto text-red-500' />
        <h1 className='mt-4 text-2xl font-semibold text-gray-900'>Something went wrong</h1>
        <div className='text-gray-600'>
          <p className='mt-2 '>An error occurred. Try reloading the page</p>
          <p className='mt-2'>If this continues, please contact the Maverick team.</p>
          {error instanceof Error && (
            <details className='mt-4' open>
              <p>{error.message}</p>
            </details>
          )}
        </div>
        <div className='mt-6 flex w-full justify-evenly'>
          <Button
            className='w-32'
            onClick={() => {
              window.location.reload();
            }}
          >
            Reload
          </Button>
          <Link to={'/app'}>
            <Button className='w-32'>Home</Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}
